import { LocalNotification, PartitionedBanners } from './types';

export const getPartitionedBanners = (
  banners: LocalNotification[],
): PartitionedBanners => {
  return banners.reduce(
    (prev: PartitionedBanners, banner) => {
      const bannerType = banner.type.toLowerCase();
      if (Array.isArray(prev[bannerType])) {
        prev[bannerType].push(banner);
      }
      prev.total += 1;
      return prev;
    },
    {
      error: [],
      warning: [],
      info: [],
      total: 0,
    },
  );
};
